import { useMemo } from "react";
import { ToggleGroup, ToggleGroupItem } from "components/ui/toggle-group";
import { Text } from "components/text";
import { countries as allCountries } from "shared/constants";

export const SearchTermsCountryToggle = ({
  countryCodes,
  value,
  onChange,
}: {
  countryCodes: string[];
  value: string;
  onChange: (countryCode: string) => void;
}) => {
  const countries = useMemo(
    () =>
      allCountries.filter((country) =>
        countryCodes.includes(country.country_code),
      ),
    [countryCodes],
  );

  return (
    <ToggleGroup
      value={value}
      variant="outline"
      type="single"
      onValueChange={onChange}
    >
      {countries.map((country) => (
        <ToggleGroupItem
          key={country.country_code}
          value={country.country_code}
          aria-label={country.country_name}
        >
          <Text>{country.country_name}</Text>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};
